<script setup lang="ts">
import { Toaster as Sonner, type ToasterProps } from 'vue-sonner'

defineProps<ToasterProps>()
</script>

<template>
  <Sonner
    class="toaster group"
    :style="{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',
    }"
    v-bind="$props"
  />
</template>
